/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { lineString } from '@turf/helpers';
import turfLength from '@turf/length';

export type Lat = number;
export type Lng = number;
export type Elevation = number;
type Distance = number;

export function mergeCoordinatesAndElevation(
  coordinates: Array<[Lat, Lng]>,
  elevation: Array<[Distance, Elevation]>
): Array<[Lat, Lng, Elevation]> {
  if (elevation.length === 0 || coordinates.length === 0) {
    return [];
  }

  const numCoords = coordinates.length;
  const coordinatesAndElevation = new Array<[number, number, number]>(
    numCoords
  );
  let distanceSoFar = 0;
  let elevationIndex = 0;
  let elevationDistance = elevation[0]![0];

  for (let i = 0; i < numCoords - 1; i++) {
    const turfLine = lineString([
      // turfLine expects [lng, lat] rather than [lat, lng]
      [coordinates[i]![1], coordinates[i]![0]],
      [coordinates[i + 1]![1], coordinates[i + 1]![0]]
    ]);
    const thisLegDistance = turfLength(turfLine) * 1_000; // turf.length is in km
    distanceSoFar += thisLegDistance;

    while (
      elevationIndex < elevation.length - 1 &&
      elevationDistance <= distanceSoFar
    ) {
      elevationIndex++;
      elevationDistance = elevation[elevationIndex]![0];
    }
    coordinatesAndElevation[i] = [
      coordinates[i]![0]!,
      coordinates[i]![1]!,
      elevation[elevationIndex]![1]
    ];
  }

  // The last item in coordinatesAndElevation is undefined because
  // of the coordinates[i + 1] in the for loop, so we need to set it here.
  coordinatesAndElevation[numCoords - 1] = [
    coordinates[numCoords - 1]![0],
    coordinates[numCoords - 1]![1],
    // just repeating the previous point elevation for now
    coordinatesAndElevation[numCoords - 2]![2]
  ];

  return coordinatesAndElevation;
}
